const pagination = {
  perPage: 10,
  currentPage: 1,
  total: 0,
  perPageOptions: [5, 10, 20, 25, 50],
};

const pagination2 = { ...pagination };

const functions = {
  pagedData() {
    return this.tableData.slice(this.from, this.to);
  },

  pagedData2() {
    return this.tableData2.slice(this.from2, this.to2);
  },

  queriedData() {
    let result = this.tableData;
    if (this.searchQuery !== '') {
      result = this.fuseSearch.search('=' + this.searchQuery + '');
    }
    this.pagination.total = result.length;

    return result.slice(this.from, this.to);
  },

  queriedData2() {
    let result = this.tableData2;
    if (this.searchQuery2 !== '') {
      result = this.fuseSearch2.search('=' + this.searchQuery2 + '');
    }
    this.pagination2.total = result.length;

    return result.slice(this.from2, this.to2);
  },

  to() {
    let highBound = this.from + this.pagination.perPage;
    if (this.total < highBound) {
      highBound = this.total;
    }

    return highBound;
  },

  to2() {
    let highBound = this.from2 + this.pagination2.perPage;
    if (this.total2 < highBound) {
      highBound = this.total2;
    }

    return highBound;
  },

  from() {
    return this.pagination.perPage * (this.pagination.currentPage - 1);
  },

  from2() {
    return this.pagination2.perPage * (this.pagination2.currentPage - 1);
  },

  total() {
    return this.pagination.total;
  },

  total2() {
    return this.pagination2.total;
  },
};

export default { pagination, pagination2, functions };
